import { Link } from "react-router-dom";
import homeicon from '../../icon/home.png'
import shopicon from '../../icon/shop.png'
import abouticon from '../../icon/about.png'
import connecticon from '../../icon/connect.png'
import employmenticon from '../../icon/employment.png'
import eduction from '../../icon/eduction.png'
import productionicon from '../../icon/production.png'
import logotehranmu from '../../logo/tehranmulogo.jpg'
import onlineicon from '../../icon/online.png'
import offlineicon from '../../icon/offline.png'
import moment from "moment-jalaali";
import dateicon from '../../icon/date.png'
import iconlanguage from '../../icon/language.png'
import brandicon from '../../icon/brand.png'
import mugramicon from '../../icon/instagram.png'
import catalogicon from '../../icon/catalog.png'
import './nav.css'
import { useState } from "react";
moment.loadPersian({ dialect: "persian-modern", usePersianDigits: true });
const formatDate = (date) => {
  const options = { day: 'numeric', month: 'long', year: 'numeric' };
  return new Intl.DateTimeFormat('en-US', options).format(date);
};
export default function Nav(props) {
    const [date, setDate] = useState(moment())
      const today = new Date();
    function selecthome() {
        props.setSelectnav('/')
        document.title = 'تهران مو | خانه'
    }
    function selectstore() {
        props.setSelectnav('/store')
        document.title = 'تهران مو | محصولات'
    }
    function selectaboutme() {
        props.setSelectnav('/aboutme')
        document.title = 'تهران مو | درباره'
    }
    function selectcontact() {
        props.setSelectnav('/contact')
        document.title = 'تهران مو | تماس'
    }
    function selectemployment() {
        props.setSelectnav('/employment')
        document.title = 'تهران مو | استخدام'
    }
    function selecteduction() {
        props.setSelectnav('/eduction')
        document.title = 'تهران مو | آموزش'
    }
    function selectedproduction() {
        props.setSelectnav('/production')
        document.title = 'تهران مو | ظرفیت خالی'
    }
    function selectedbrand() {
        props.setSelectnav('/brand')
        document.title = 'تهران مو | برند'
    }
    function selectedcatalog() {
        props.setSelectnav('/catalog')
        document.title = 'تهران مو | کتلوگ'
    }
    function selectedmugram() {
        props.setSelectnav('/mugram')
        document.title = 'تهران مو | موگرام'
    }
    function seten() {
        props.setLanguage('en')
    }
    function setfa() {
        props.setLanguage('fa')
    }
    return (
        <div className="navigation">
            <div className='logotehranmu'><p><img src={props.onlineUsers === 0 ? offlineicon : onlineicon} alt="online"></img>{props.onlineUsers === 0 ? props.language === 'en' ? 'Offline' : 'آفلاین' : props.language === 'en' ? `${props.onlineUsers} Online` : `${props.onlineUsers} نفر آنلاین`}</p><img src={logotehranmu} alt='tehranmu'></img><p className="date">{props.language === 'en' ? formatDate(today) : date.format("jD jMMMM jYYYY")} <img src={dateicon}></img></p></div>
            <div className="navwidth">
            <ul className="navbox">
                <li onClick={selecthome}><Link style={props.selectnav === '/' ? { backgroundColor: "red", color: 'white' } : { backgroundColor: "white", color: 'black' }} to='/'><img src={homeicon} alt="خانه"></img><p>{props.language === 'en' ? 'Home' : 'خانه'}</p></Link></li>
                <li onClick={selectaboutme}><Link style={props.selectnav === '/aboutme' ? { backgroundColor: "red", color: 'white' } : { backgroundColor: "white", color: 'black' }} to='/aboutme'><img src={abouticon} alt="مسئولیت ما"></img><p>{props.language === 'en' ? 'Responsibility' : 'مسئولیت ما'}</p></Link></li>
                <li onClick={selectedbrand}><Link style={props.selectnav === '/brand' ? { backgroundColor: "red", color: 'white' } : { backgroundColor: "white", color: 'black' }} to='/brand'><img src={brandicon} alt="برند"></img><p>{props.language === 'en' ? 'Brand' : 'برند'}</p></Link></li>
                <li onClick={selectstore}><Link style={props.selectnav === '/store' ? { backgroundColor: "red", color: 'white' } : { backgroundColor: "white", color: 'black' }} to='/store'><img src={shopicon} alt="محصولات"></img><p>{props.language === 'en' ? 'Products' : 'محصولات'}</p></Link></li>
                <li onClick={selectedcatalog}><Link style={props.selectnav === '/catalog' ? { backgroundColor: "red", color: 'white' } : { backgroundColor: "white", color: 'black' }} to='/catalog'><img src={catalogicon} alt="کاتالوگ"></img><p>{props.language === 'en' ? 'Catalog' : 'کاتالوگ'}</p></Link></li>
                <li onClick={selectedmugram}><Link style={props.selectnav === '/mugram' ? { backgroundColor: "red", color: 'white' } : { backgroundColor: "white", color: 'black' }} to='/mugram'><img src={mugramicon} alt="موگرام"></img><p>{props.language === 'en' ? 'Mugram' : 'موگرام'}</p></Link></li>
                <li onClick={selecteduction}><Link style={props.selectnav === '/eduction' ? { backgroundColor: "red", color: 'white' } : { backgroundColor: "white", color: 'black' }} to='/eduction'><img src={eduction} alt="آموزش"></img><p>{props.language === 'en' ? 'Education' : 'آموزش'}</p></Link></li>
                <li onClick={selectedproduction}><Link style={props.selectnav === '/production' ? { backgroundColor: "red", color: 'white' } : { backgroundColor: "white", color: 'black' }} to='/production'><img src={productionicon} alt="ظرفیت خالی"></img><p>{props.language === 'en' ? 'Capacity' : 'ظرفیت خالی'}</p></Link></li>
                {/* <li onClick={selectemployment}><Link style={props.selectnav === '/employment' ? { backgroundColor: "red", color: 'white' } : { backgroundColor: "white", color: 'black' }} to='/employment'><img src={employmenticon} alt="استخدام"></img><p>استخدام</p></Link></li> */}
                <li onClick={selectcontact}><Link style={props.selectnav === '/contact' ? { backgroundColor: "red", color: 'white' } : { backgroundColor: "white", color: 'black' }} to='/contact'><img src={connecticon} alt="تماس"></img><p>{props.language === 'en' ? 'Contact' : 'تماس'}</p></Link></li>
            </ul>
            <div className="languagepcbox">
                <img src={iconlanguage}></img>
            <div className="languagepc">
                <div><p onClick={seten}>English</p> | <p onClick={setfa}>فارسی</p></div>
            </div>
            </div>
            <div className="tehranmulogo"><h1 className="nameweb">{props.language === 'en' ? 'Tehranmu' : 'تهران مو'}</h1><img src={logotehranmu}></img></div>
            </div>
        </div>
    )
}